import React from 'react';
import styled from 'styled-components';
import {
    FormControl,
    InputLabel,
    Select as MUISelect,
} from '@material-ui/core';
import { SelectProps, Box, Typography } from '@material-ui/core';

interface IProps extends Omit<SelectProps, 'error'> {
    className?: string;
    error?: string;
    id: string;
    label: string;
}

const BaseSelect: React.FC<IProps> = ({
    children,
    className,
    error,
    id,
    label,
    ...selectProps
}) => (
    <FormControl className={className} variant="filled">
        <InputLabel id={id}>{label}</InputLabel>
        <MUISelect
            error={!!error}
            id={id}
            labelId={id}
            MenuProps={{
                disableScrollLock: true,
            }}
            {...selectProps}
        >
            {children}
        </MUISelect>
        <Box mt={2}>
            <Typography color="error">{error}</Typography>
        </Box>
    </FormControl>
);

export const Select = styled(BaseSelect)`
    width: 100%;
    .MuiFormLabel-root {
        width: 100%;
        color: ${({ theme }) => theme.palette.grey[200]};
    }
    .MuiInputBase-root {
        background-color: ${({ theme }) => theme.palette.grey[50]};
        min-height: 65px;
        ::before {
            display: none;
        }
    }
    .MuiInputLabel-formControl {
        top: 6px;
    }
    .MuiSelect-icon {
        top: 16px;
        color: ${({ theme }) => theme.palette.grey[200]};
        width: 30px;
        height: 30px;
    }
`;
